import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import { useLocation, Link } from 'react-router-dom';
import LogoSengital from '../static/LogoSengital.png';
import "../styles/Header.css";

const Header = () => {
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className="header">
            <div className="header-container">
                <div className="header-content">
                    <div className="logo">
                        <img src={LogoSengital} width={200} alt="Sengital Logo" />
                    </div>

                    <nav className={`nav-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
                        <Link
                            to="/"
                            className={`nav-button ${location.pathname === '/' ? 'active' : ''}`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/moffice"
                            className={`nav-button ${location.pathname === '/moffice' ? 'active' : ''}`}
                        >
                            Moffice.AI
                        </Link>
                        <Link
                            to="https://sengital.ai/"
                            className={`nav-button ${location.pathname === '/about' ? 'active' : ''}`}
                        >
                            About Us
                        </Link>
                        <Link
                            to="/auth"
                            className={`login-button ${location.pathname === '/auth' ? 'active' : ''}`}
                        >
                            Login
                            <LogIn size={18} />
                        </Link>
                    </nav>

                    <div className="mobile-menu">
                        <button className="mobile-menu-button" onClick={toggleMobileMenu}>
                            <svg className="menu-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;